import { React, forwardRef } from 'react';
import '../App.css';

const LampIcon = forwardRef((props, ref)  => {
  return (
    <svg ref={ref} {...props} version="1.1" id="lamp-icon-layer" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 300 300" enable-background="new 0 0 300 300" xmlSpace="preserve">
		<g id="circle">
			<circle id="circleBg" fill="#d4aa2d" cx="150" cy="150" r="150"/>
		</g>
		<g>
			<path id="lamp132" fill="#black" d="M159.2,142.5h-11.4h0h-11.4l2.8,65.3h17.3L159.2,142.5z M142.9,258.2h9.7c6.5,0,12-4,14.2-9.8
				h-38C131,254.2,136.5,258.2,142.9,258.2z M121.4,231.7h52.8c2.2,0,4,1.8,4,4v1.4c0,2.2-1.8,4-4,4h-52.8c-2.2,0-4-1.8-4-4v-1.4
				C117.4,233.5,119.2,231.7,121.4,231.7z M178.2,219.1c0-2.2-1.8-4-4-4h-14.3c0,0,0,0,0,0c0,0-0.1,0-0.1,0h-24.1c0,0-0.1,0-0.1,0
				c0,0,0,0,0,0h-14.3c-2.2,0-4,1.8-4,4v1.4c0,2.2,1.8,4,4,4h52.8c2.2,0,4-1.8,4-4V219.1z M222.7,130.4c0-25.2-12.5-48.7-33.5-62.7
				c-21.4-14.3-48.1-16.4-73.2-6c-16.5,6.9-29.8,20.3-36.6,36.9c-19,46.3,5.8,86.4,38.7,100.7c3.4,1.5,5.7,4.7,6.2,8.4h7.7l-2.8-65.3
				h-4.9c-8.9,0-16.2-7.2-16.2-16.2c0-7.6,6.2-13.8,13.8-13.8c7.4,0,13.5,5.8,13.8,13.2l0.4,9.5h23.4l0.4-9.5
				c0.3-7.4,6.4-13.2,13.8-13.2c7.6,0,13.8,6.2,13.8,13.8c0,8.9-7.2,16.2-16.2,16.2h-4.9l-2.8,65.3h7.7c0.4-3.7,2.7-6.9,6.2-8.4
				C205,187.5,222.7,160.4,222.7,130.4L222.7,130.4z M180.3,126.4c0-3.6-2.9-6.6-6.6-6.6c-3.5,0-6.4,2.8-6.5,6.3l-0.4,9.2h4.6
				C176.3,135.3,180.3,131.3,180.3,126.4z M121.9,119.8c-3.6,0-6.6,2.9-6.6,6.6c0,4.9,4,8.9,8.9,8.9h4.6l-0.4-9.2
				C128.3,122.6,125.4,119.8,121.9,119.8z"/>
			<path id="heart" display="none" fill="#CE4545" d="M66.5,71.4L66.5,71.4c-6,3.4-10.2,9.4-11.4,16.2c-6.5-2.4-13.8-1.7-19.8,1.8
				c-11.3,6.5-15.2,21-8.6,32.3c11.2,19.4,55.9,18.7,57.6,18.7c0.8,0.1,1.5-0.4,1.8-1.1c0.9-1.5,24-39.6,12.6-59.3
				C92.2,68.8,77.7,64.9,66.5,71.4z"/>
		</g>
	</svg>
  );
})

export default LampIcon;